// import logo from './logo.svg';
import "./App.less";
import Presentation from "./pages/presentation";
import Competences from "./pages/Competences";
import Experiences from "./pages/Experiences";
import Realisation from "./pages/Realisation";
import Contact from "./pages/Contact";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Formation from "./pages/Formation";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Presentation />} />
        <Route path="presentation" element={<Presentation />} />
        <Route path="/competences" element={<Competences />} />
        <Route path="/formation" element={<Formation />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/realisation" element={<Realisation />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
